import * as yup from 'yup'

export default yup.object().shape({
  number: yup.string().required('O campo Número do Cartão é requerido.'),
  name: yup.string().required('O campo Nome no Cartão é requerido.'),
  expiry: yup.string().required('Campo requerido.'),
  cvc: yup.string().required('Campo requerido.'),
  birth: yup.string().required('Campo requerido.')
})
